export enum OrbitAddOwnerStep {
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  ADDED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  REJECTED_BY_THE_USER,
}
